import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import OptionalLazyBoundary from 'components/OptionalLazyBoundary';
import { COPILOT_BAR, COPILOT_BAR_LIVE } from 'constants/Features';
import { lazyOptional } from 'utils/lazyOptional';

import { loadCopilotBar } from './loadCopilotBar';
import useCopilotBarScenarioMatch from './useCopilotBarScenarioMatch';

const CopilotBar = lazyOptional(loadCopilotBar);

const EnabledCopilotBar = memo(({ fallback }) => {
    const scenarioMatch = useCopilotBarScenarioMatch();

    return (
        <OptionalLazyBoundary fallback={fallback}>
            <CopilotBar scenarioMatch={scenarioMatch} />
        </OptionalLazyBoundary>
    );
});

EnabledCopilotBar.displayName = 'EnabledCopilotBar';

const LazyCopilotBar = memo(({ fallback = null }) => {
    const isCopilotBarEnabled = useSelector((state) => {
        const flagsmith = state.config?.flagsmith || {};
        return Boolean(flagsmith[COPILOT_BAR] || flagsmith[COPILOT_BAR_LIVE]);
    });

    if (!isCopilotBarEnabled) return null;

    return <EnabledCopilotBar fallback={fallback} />;
});

LazyCopilotBar.displayName = 'LazyCopilotBar';

export default LazyCopilotBar;
